import React from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithInput.js";
import Features from "components/features/ThreeColWithSideImage.js";
import HoverImgFeature from "components/features/TwoColWithHoverImgShow.js";
import MainFeature2 from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
// import FeatureWithSteps from "components/features/TwoColWithSteps.js";
import Header from "../components/headers/light.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";
import FAQ from "components/faqs/SingleCol.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import heroScreenshotImageSrc from "images/hero-screenshot-1.png";
// import ThreePlansWithHalfPrimaryBackgroundPricing from "components/pricing/ThreePlansWithHalfPrimaryBackground.js";
// import macHeroScreenshotImageSrc from "images/hero-screenshot-2.png";
import prototypeIllustrationImageSrc from "images/prototype-illustration.svg";
import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/dollar-sign.svg";

export default () => {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
  const HighlightedText = tw.span`text-primary-100`;

  return (
    <>
      <Header roundedHeaderButton={false} />
      <AnimationRevealPage>
        <Hero />
        <Features
          subheading={<Subheading></Subheading>}
          heading={
            <>
              There is nothing like Tabebek's{" "}
              <HighlightedText>Services.</HighlightedText>
            </>
          }
        />
        <HoverImgFeature
          subheading={<Subheading>Quality Work</Subheading>}
          imageSrc={heroScreenshotImageSrc}
          imageBorder={true}
          imageDecoratorBlob={true}
        />

        {/* <FeatureWithSteps
        subheading={<Subheading>STEPS</Subheading>}
        heading={
          <>
            Easy to <HighlightedText>Get Started.</HighlightedText>
          </>
        }
        textOnLeft={false}
        imageSrc={macHeroScreenshotImageSrc}
        imageDecoratorBlob={true}
        decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-15 -translate-x-1/2 left-1/2`}
      /> */}
        <MainFeature2
          subheading={<Subheading>VALUES</Subheading>}
          heading={
            <>
              We Always Abide by Our{" "}
              <HighlightedText>Principles.</HighlightedText>
            </>
          }
          imageSrc={prototypeIllustrationImageSrc}
          showDecoratorBlob={false}
          features={[
            {
              Icon: MoneyIcon,
              title: "Affordable",
              description:
                "We promise to offer you the best rate we can - at par with the industry standard.",
              iconContainerCss: tw`bg-green-300 text-green-800`,
            },
            {
              Icon: BriefcaseIcon,
              title: "Professionalism",
              description:
                "We have the best professional and skilled team across the globe just to work with you.",
              iconContainerCss: tw`bg-red-300 text-red-800`,
            },
          ]}
        />
        {/* <ThreePlansWithHalfPrimaryBackgroundPricing
          subheading=""
          heading={<>Pricing</>}
          primaryButtonText="Select"
        /> */}
        <Testimonial
          subheading={<Subheading>Testimonials</Subheading>}
          heading={
            <>
              Our Clients <HighlightedText>Love Us.</HighlightedText>
            </>
          }
          testimonials={[
            {
              stars: 5,
              profileImageSrc:
                "https://static.vecteezy.com/system/resources/thumbnails/003/687/115/small/muslim-woman-head-free-vector.jpg",
              heading: "Amazing User Experience",
              quote:
                "If you are thinking about a group practice, I would say get your electronic records system in place and comfortable with it. Tabebek has been great for operating our practice. Their Customer service is par value.",
              customerName: "Ms. Shams Albounain",
              customerTitle: "Owner at ChildSpark Clinic",
            },
            {
              stars: 5,
              profileImageSrc:
                "https://www.shutterstock.com/image-vector/arabic-man-traditional-muslim-hat-260nw-517991671.jpg",
              heading: "Love the Developer Experience and Design Principles !",
              quote:
                "Tabebek has amazing features and we are having great user experience to run our clinic operations. We have amazing experience to work with such professional people at Tabebek.",
              customerName: "Mr. Bandar Alaraj",
              customerTitle: "Owner at ChildWill Clinic",
            },
          ]}
        />
        <FAQ
          subheading={<Subheading>FAQS</Subheading>}
          heading={
            <>
              You have <HighlightedText>Questions ?</HighlightedText>
            </>
          }
          faqs={[
            {
              question: "Do you have local laws complainces ?",
              answer:
                "Yes, we are having laws complainces like ministry of health(MOH) and ZATCA.",
            },
            {
              question: "How long it takes to implement tabebek ?",
              answer: "We have quick implementation with a professional team.",
            },
            {
              question: "Do you support post implementation ?",
              answer:
                "Yes, we have dedicated customer support teams to look after their queries.",
            },
            {
              question:
                "Do you have any charges other than the monthly subscription fee ?",
              answer: "No, we only charge you the agreed prices.",
            },
            // {
            //   question: "Do you provide demo account of your EHR free ?",
            //   answer: "Yes, we provide free demo account.",
            // },
          ]}
        />
        {/* <GetStarted/> */}
        <Footer />
      </AnimationRevealPage>
    </>
  );
};
